import { render } from "./EmployeesView.vue?vue&type=template&id=79b7da13&scoped=true"
import script from "./EmployeesView.vue?vue&type=script&lang=js"
export * from "./EmployeesView.vue?vue&type=script&lang=js"

import "./EmployeesView.vue?vue&type=style&index=0&id=79b7da13&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b7da13"]])

export default __exports__